import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { getProduct } from "../../Services/ProductService";
import { useSelector } from "react-redux";
import { getLanguages } from "../../Services/LanguageService";
import { getAppList, getImageFunc, getVideoFunc } from "../../Services/AppService";
import { getSeriesAll } from "../../Services/SeriesService";
import { getSeupplier } from "../../Services/SAPService";
import Swal from "sweetalert2";
import Overlay from "../../Components/Overlay/Overlay";
import SkuEdit from "../../Components/Product/SkuEdit";
import bwipjs from "bwip-js";
import { getIotSeriesAll } from "../../Services/IoTSeriesService";
import { getSubSubcategoryAll } from "../../Services/SubSubcategoryService";
import ProductDimensionView from "../../Components/ProductView/ProductDimensionView";

// for product details
import { getAllAssembles } from "../../Services/AssemblyServices";
import { getSegmentAll } from "../../Services/SegmentService";
import { getExportFile, getImportFile } from "../../Services/FileService";
import { getProductsAll } from "../../Services/ProductService";
import { capitalizeFirstLetter } from "../../Utils/Utils";
import ProductDetailPageView from "./ProductDetailPageView";
import { ProductImageView } from "../../Components/ProductView/ProductImageView";
import { ProductVideoView } from "../../Components/ProductView/ProductVideoView";

const { $ } = window;

const ProductDetailView = () => {
  const darkMode = useSelector((state) => state.theme.darkMode);
  let { userInfo } = useSelector((state) => state.auth);
  const { country_code, item_code } = useParams();
  const navigate = useNavigate();

  const { watch, getValues, setValue } = useForm({
    defaultValues: {
      model_code: "",
      item_name: "",
      item_code_original: "",
      group_code: "",

      // Product Detail
      id_segment: "1",
      id_category: "",
      id_sub_category: "",
      id_sub_sub_category: 0,
      id_series: 0,
      id_brand: "",

      prefix: "",
      color: "",
      country_code: "",
      certificate: "",
      electrical_rating: "",
      assembly: "",
      part_change_sequence: "",
      part_change_location: "",
      unit: "",
      series: "",

      // Dimension
      height: 0,
      width: 0,
      length: 0,
      depth: 0,
      weight: 0,
      volume: 0,

      outer_height: 0,
      outer_width: 0,
      outer_length: 0,
      outer_depth: 0,
      outer_weight: 0,

      cut_out_height: 0,
      cut_out_width: 0,
      cut_out_length: 0,
      cut_out_depth: 0,

      cut_out_height_topmount: 0,
      cut_out_width_topmount: 0,
      cut_out_length_topmount: 0,

      cut_out_height_undermount: 0,
      cut_out_width_undermount: 0,
      cut_out_length_undermount: 0,

      // Misc
      weight_type: "",
      scale: "",
      launch_date: "",
      cardcode: "",
      barcode_sni: "",
      barcode_qr: "",

      is_active: true,
      is_publish_web: false,
      is_manage_serial: false,

      numRows: 1,
      numRowsUps: 1,

      product_class: "",
    },
  });

  const [state, setState] = useState({
    is_creation_approved: false,
    canvasUrl: [],
    countryCode: "",
    itemCode: "",
    incident_id: null,
    incident_status: null,
    next_step_nik: null,
    next_step_name: null,
    activeTab: "tab1",
    feature_update: [],
    org_id_sub_sub_category: 0,

    product: null,
    countryChange: country_code,
    selectedSupplierCode: "",
    suppliers: [],
    files: [],
    manualBooksDelete: [],
    manualBooks: [],
    filesDescs: [],
    videoDescs: [],
    fileSelected: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    filesNew: [],
    filesDescsNew: [],
    fileSelectedNew: {
      fileName: "",
      media_desc: "",
      media_types: [],
      content_types: [],
    },
    videoSelected: "",
    video_types: [],
    media_types: [],
    content_types: [],
    languages: [],
    selectedLang: {
      language_code: "",
      language_name: "",
    },
    productDetails: [],
    productDetail: {
      language_code: "",
      language_name: "",
      title: "",
      header_description: "",
      description: "",
      feature: "",
      including: "",
      tagline: "",
      price: "",
      manual_book: "",
      is_preorder: 0,
      is_rental: 0,
      is_active: true,
      is_me_by_modena: 0,
      sku_me_by_modena: "",
      sticker_price: 0,
      seo_title: "",
      seo_description: "",
      url_ar: "",
    },
    productHighlights: [],
    productHighlight: [],
    productUpss: [],
    productUps: [],
    filesUps: [],
    filesDescsUps: [],
    filesDescsUpss: [],
    fileSelectedUps: {
      fileNameUps: "",
      media_desc: "",
      language_code: "",
      line_num: "",
      media_types: [],
      content_types: [],
    },
    productEcom: [],
    reqFeature: [],
    totScoreFeature: 0,
    processing: false,
    videoUrl: "",
    videoLang: "",
    numRows: 1,
    numRowsUps: 1,
    sub_sub_category: {},
    deletedFile: [],
    deletedDetail: [],
    deletedFileNew: [],
    deletedFileUps: [],
    deletedHighlight: [],
    deletedUps: [],
    deletedUpsTag: [],
    deletedVideo: [],
    deletedEcom: [],

    products: [],
    selectedItemCode: "",
    segments: [],
    categories: [],
    subcategories: [],
    subsubcategories: [],
    pseries: [],
    id_sub_sub_category: 0,
    id_series: 0,
    image_change: false,
    colors: [],
    countries: [],
    certs: [],
    eratings: [],
    assembles: [],
    pcls: [],
    brands: [],
    subprefixs: [],
    skuHeaders: [],
    sku: [],
    activeIndex: -1,
    firstPrefix: "",
    secondPrefix: "",
    firstColor: "",
    secondColor: "",
    firstCountry: "",
    secondCountry: "",
    cert: "",
    erating: "",
    assembly: "",
    partSequence: "",
    pcl: "",
    filesBase64: [],
    brandPrefix: "",
    is_active: true,
    is_publish_web: false,
    is_manage_serial: false,
    deleteEcom: [],
    feature_type: [],
    show: false,
    activeSubTab: "tab1",
  });

  useEffect(() => {
    if (getValues("id_sub_category") && getValues("id_sub_category") > 0) {
      getSubSubcategoryAll({
        filter: `id_sub_category:${getValues("id_sub_category")}`,
      }).then((res) => {
        if (res.status == 200 && (!sub_sub_category || Object.keys(sub_sub_category).length === 0)) {
          setState({
            ...state,
            sub_sub_category: res.data,
          });
        }
      });
    }
  }, [getValues("id_sub_category")]);

  useEffect(() => {
    if (!userInfo.access?.master_product_view?.can_view) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "You're not allowed to access that page!",
      }).then(() => navigate("/"));
    }
    const reqVideoType = getVideoFunc({ perpage: 1000 }).then((res) => res.data.data);
    const reqMediaType = getImageFunc({ perpage: 1000 }).then((res) => res.data.data);
    const reqContentType = getAppList({ perpage: 1000 }).then((res) => res.data.data);
    const reqProduct = getProduct(item_code, "master").then((res) => res.data);
    const reqLanguage = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqSeries = getSeriesAll({ perpage: 1000 }).then((res) => res.data.data);
    const reqIotSeries = getIotSeriesAll({ perpage: 1000 }).then((res) => res.data.data);
    Promise.all([reqVideoType, reqMediaType, reqContentType, reqProduct, reqLanguage, reqSeries, reqIotSeries]).then((results) => {
      const [_video_types, _media_types, _content_types, _product, _languages, _pseries, _iotseries] = results;
      for (const key in _product.filesDescs[0]) {
        filesDescs[key] = {
          fileName: _product.filesDescs[0][key].fileName,
          media_desc: _product.filesDescs[0][key].media_desc,
          media_types: _product.filesDescs[0][key].media_types,
          content_types: _product.filesDescs[0][key].content_types,
          skip: _product.filesDescs[0][key].skip,
        };
      }

      for (const key in _product.filesDescsNew[0]) {
        filesDescsNew[key] = {
          fileName: _product.filesDescsNew[0][key].fileName,
          media_desc: _product.filesDescsNew[0][key].media_desc,
          media_types: _product.filesDescsNew[0][key].media_types,
          content_types: _product.filesDescsNew[0][key].content_types,
          skip: _product.filesDescsNew[0][key].skip,
        };
      }

      for (const key in _product.videoDescs[0]) {
        videoDescs[key] = {
          filePath: _product.videoDescs[0][key].filePath,
          fileName: _product.videoDescs[0][key].fileName,
          id: _product.videoDescs[0][key].id,
          media_types: _product.videoDescs[0][key].media_types,
          media_desc: _product.videoDescs[0][key].media_desc,
          content_types: _product.videoDescs[0][key].content_types,
          language_code: _product.videoDescs[0][key].language_code,
          language_name: _product.videoDescs[0][key].language_name,
        };
      }
      const _sub_sub_category = _product.product?.subsubcategories?.find((item) => item.id == _product.product.id_sub_sub_category);

      setState({
        ...state,
        is_creation_approved: _product.product.is_creation_approved,
        countryCode: _product.product.country_code,
        itemCode: _product.product.item_code,
        subsubcategories: _product?.product?.subsubcategories?.length > 0 ? _product.product.subsubcategories : [],
        pseries: _product.product.pseries.length > 0 ? _product.product.pseries : _pseries,
        iotseries: _iotseries,
        countryChange: _product.product.country_code,
        next_step_nik: _product.product.next_step_nik || null,
        next_step_name: _product.product.next_step_name || null,
        incident_id: _product.product.incident_id || null,
        incident_status: _product.product.incident_status || null,
        next_step_nik_detail: _product.product.next_step_nik_detail || null,
        next_step_name_detail: _product.product.next_step_name_detail || null,
        incident_id_detail: _product.product.incident_id_detail || null,
        incident_status_detail: _product.product.incident_status_detail || null,
        video_types: _video_types,
        media_types: _media_types,
        content_types: _content_types,
        languages: _languages,
        product: _product.product,
        files: _product.files,
        filesNew: _product.filesNew,
        filesUps: _product.filesUps ? _product.filesUps : [],
        productUps: _product.productUps
          ? _product.productUps
          : [
              {
                name: "",
                media_code: "",
                media_type: [],
                media_desc: "",
                content_type: [],
                file_path: "",
                tags: [],
              },
            ],
        filesDescs: filesDescs,
        filesDescsNew: filesDescsNew,
        fileSelectedNew: _product.fileSelectedNew,
        filesDescsUps: filesDescsUps,
        filesDescsUpss: filesDescsUps,
        videoDescs: videoDescs,
        productDetails: _product.productDetails,
        productDetail:
          _product.productDetails.length > 0
            ? _product.productDetails[0]
            : {
                language_code: "",
                language_name: "",
                title: "",
                header_description: "",
                description: "",
                feature: "",
                including: "",
                tagline: "",
                price: 0,
                manual_book: null,
                is_preorder: 0,
                is_rental: 0,
                is_active: true,
                is_publish_web: false,
                is_me_by_modena: 0,
                sku_me_by_modena: "",
                sticker_price: 0,
                seo_title: "",
                seo_description: "",
                url_ar: "",
              },
        productHighlights: _product.productHighlights,
        reqFeature: _product.feature_type ? _product.feature_type : [],
        totScoreFeature: _product.totScoreFeature,
        productEcom: _product.productEcom ? _product.productEcom : [{ id_store: "", url: "", price: "", line_num: 0 }],
        sub_sub_category: _sub_sub_category,
        org_id_sub_sub_category: _product.product.id_sub_sub_category,
        product_class: _product.product.product_class,
      });

      setValue("id_segment", _product.product.id_segment);
      setValue("id_category", _product.product.id_category);
      setValue("id_sub_category", _product.product.id_sub_category);
      setValue("id_sub_sub_category", _product.product.id_sub_sub_category);
      setValue("id_brand", _product.product.id_brand);
      setValue("height", _product.product.height);
      setValue("width", _product.product.width);
      setValue("weight", _product.product.weight);
      setValue("weight_type", _product.product.weight_type);
      setValue("length", _product.product.length);
      setValue("depth", _product.product.depth);
      setValue("volume", _product.product.volume);
      setValue("thickness", _product.product.thickness);
      setValue("outer_height", _product.product.outer_height);
      setValue("outer_width", _product.product.outer_width);
      setValue("outer_depth", _product.product.outer_depth);
      setValue("outer_weight", _product.product.outer_weight);
      setValue("outer_length", _product.product.outer_length);
      setValue("cut_out_height", _product.product.cut_out_height);
      setValue("cut_out_width", _product.product.cut_out_width);
      setValue("cut_out_length", _product.product.cut_out_length);
      setValue("cut_out_depth", _product.product.cut_out_depth);
      setValue("cut_out_height_topmount", _product.product.cut_out_height_topmount);
      setValue("cut_out_width_topmount", _product.product.cut_out_width_topmount);
      setValue("cut_out_length_topmount", _product.product.cut_out_length_topmount);
      setValue("cut_out_height_undermount", _product.product.cut_out_height_undermount);
      setValue("cut_out_width_undermount", _product.product.cut_out_width_undermount);
      setValue("cut_out_length_undermount", _product.product.cut_out_length_undermount);
      setValue("model_code", _product.product.model_code);
      setValue("item_name", _product.product.item_name);
      setValue("group_code", _product.product.group_code);
      setValue("scale", _product.product.scale);
      setValue("cardcode", _product.product.cardcode);
      setValue("launch_date", _product.product.launch_date);
      setValue("barcode_sni", _product.product.barcode_sni);
      setValue("barcode_qr", _product.product.barcode_qr);
      setValue("is_active", _product.product.is_active);
      setValue("is_publish_web", _product.product.is_publish_web);
      setValue("is_manage_serial", _product.product.is_manage_serial);
      setValue("product_class", _product.product.product_class);
      setValue("item_code_original", _product.product.item_code_original);
      setValue("id_series", _product.product.id_series);
      setValue("code_iot_series", _product.product.code_iot_series);

      setTimeout(() => {
        genBarcode(null, _product.product.barcode_sni);
        genQRCode(null, _product.product.barcode_qr);
      }, 150);
    });
    $("#launch_date").datetimepicker({
      format: "YYYY-MM-DD",
    });
  }, []);

  const genBarcode = (e, value) => {
    try {
      bwipjs.toCanvas("barcode", {
        bcid: "code128",
        text: value || e.target.value,
        scale: 2,
        height: 5,
        includetext: true,
        textxalign: "center",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const genQRCode = (e, value) => {
    try {
      bwipjs.toCanvas("qrcode", {
        bcid: "qrcode",
        text: value || e.target.value,
        scale: 3,
        height: 15,
        includetext: false,
        textxalign: "center",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleTabClick = (tab) => {
    setState({ ...state, activeTab: tab });
  };

  const {
    filesDescs,
    product,
    productDetails,
    processing,
    videoDescs,
    selectedSupplierCode,
    canvasUrl,
    countryCode,
    itemCode,
    filesDescsNew,
    filesDescsUps,
    subsubcategories,
    sub_sub_category,
  } = state;

  useEffect(() => {
    if (selectedSupplierCode != "" && selectedSupplierCode.length >= 4) {
      const timeOut = setTimeout(() => {
        getSeupplier(selectedSupplierCode, { perpage: 10 }, ({ data }) => {
          setState({ ...state, suppliers: data.data });
        });
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedSupplierCode]);

  useEffect(() => {
    const _canvasUrl = [];
    productDetails.map((item) => {
      if (item.language_code) {
        let code = item.language_code.toUpperCase();
        if (countryCode !== "id") {
          code = item.language_code.toUpperCase();
          if (countryCode === "ae") {
            code = "UAE";
          }
        }
        const url = `${process.env.REACT_APP_O2O}${code}/${itemCode}`;
        _canvasUrl.push({
          id: `qr-${item.item_code}-${item.language_code}`,
          value: url,
        });
      }
    });

    setState({ ...state, canvasUrl: _canvasUrl });
  }, [productDetails]);

  useEffect(() => {
    if (state.activeTab !== "tab1") return;

    const timeout = setTimeout(() => {
      genBarcode(null, getValues("barcode_sni"));
      genQRCode(null, getValues("barcode_qr"));
    }, 50);

    return () => clearTimeout(timeout);
  }, [state.activeTab]);

  useEffect(() => {
    if (state.activeTab !== "tab2" || canvasUrl.length === 0) return;

    const timeout = setTimeout(() => {
      for (const key in canvasUrl) {
        try {
          bwipjs.toCanvas(canvasUrl[key].id, {
            bcid: "qrcode",
            text: canvasUrl[key].value,
            scale: 3,
            height: 15,
            includetext: false,
            textxalign: "center",
          });
        } catch (e) {
          console.log(e);
        }
      }
    }, 50);

    return () => clearTimeout(timeout);
  }, [canvasUrl, state.activeTab]);

  useEffect(() => {
    const reqSegment = getSegmentAll({ perpage: 1000 }).then((res) => res.data.data);
    const reqLang = getLanguages({
      orders: "language_name:asc",
      perpage: 1000,
    }).then((res) => res.data.data);
    const reqExportFile = getExportFile("product_master").then((res) => res.data);
    const reqImport = getImportFile("product_master").then((res) => res.data);
    const reqAssemble = getAllAssembles({ perpage: 1000 }).then((res) => res.data.data);
    const reqProduct = getProduct(item_code, "detail").then((res) => res.data);
    const reqVideoType = getVideoFunc({ perpage: 1000 }).then((res) => res.data.data);
    const reqMediaType = getImageFunc({ perpage: 1000 }).then((res) => res.data.data);
    const reqContentType = getAppList({ perpage: 1000 }).then((res) => res.data.data);
    Promise.all([reqSegment, reqLang, reqExportFile, reqImport, reqAssemble, reqProduct, reqVideoType, reqMediaType, reqContentType]).then((results) => {
      const [_segment, _langs, _fileExport, _fileImport, _assembles, _product, _video_types, _media_types, _content_types] = results;
      if (_product.mode && _product.mode == "draft") {
        setTimeout(() => {
          setState({
            ...state,
            mode: _product.mode ? " (" + _product.mode.toUpperCase() + ") " : "",
            product: _product.additionalDetails,
            languages: _langs,
            productDetails: _product.productDetails,
            productHighlights: _product.productHighlights,
            video_types: _video_types,
            media_types: _media_types,
            filesNew: _product.filesNew,
            content_types: _content_types,
            productUps: _product.productUps
              ? _product.productUps
              : [
                  {
                    name: "",
                    media_code: "",
                    media_type: "",
                    media_desc: "",
                    content_type: "",
                    file_path: "",
                    tags: [],
                  },
                ],
            productEcom: _product.productEcom ? _product.productEcom : [{ id_store: "", url: "", price: "", line_num: 0 }],
            filesDescs: _product.filesDescs,
            files: _product.files ? _product.files : [],
            filesUps: _product.filesUps ? _product.filesUps : [],
            filesDescsNew: _product.filesDescsNew,
            deletedUps: _product?.deletedUps ? _product?.deletedUps : [],
            fileSelectedNew: _product.fileSelectedNew,
            filesDescsUps: _product.filesDescsUps,
            filesDescsUpss: _product.filesDescsUps,
            videoDescs: _product.videoDescs,
            productDetail:
              _product.productDetails.length > 0
                ? _product.productDetails[0]
                : {
                    language_code: "",
                    language_name: "",
                    title: "",
                    header_description: "",
                    description: "",
                    feature: "",
                    including: "",
                    tagline: "",
                    price: 0,
                    manual_book: null,
                    is_preorder: 0,
                    is_rental: 0,
                    is_active: true,
                    is_publish_web: false,
                    is_me_by_modena: 0,
                    sku_me_by_modena: "",
                    sticker_price: 0,
                    seo_title: "",
                    seo_description: "",
                    url_ar: "",
                  },
          });
        }, 100);
      } else {
        const fExport = _fileExport.status != 404 ? _fileExport : null;
        const fImport = _fileImport.status != 404 ? _fileImport : [];
        _product.filesDescs = !Array.isArray(_product.filesDescs) ? [_product.filesDescs] : _product.filesDescs;
        let j = 0;
        for (const key in _product.filesDescs[0]) {
          if (_product.files[j]) {
            _product.files[j]["fileIndex"] = key;
          }
          filesDescs[key] = {
            fileIndex: key,
            fileName: _product.filesDescs[0][key].fileName,
            media_desc: _product.filesDescs[0][key].media_desc,
            media_types: _product.filesDescs[0][key].media_types,
            content_types: _product.filesDescs[0][key].content_types,
            skip: _product.filesDescs[0][key].skip,
          };
          j++;
        }
        _product.filesDescsNew = !Array.isArray(_product.filesDescsNew) ? [_product.filesDescsNew] : _product.filesDescsNew;
        if (_product.filesDescsNew && _product.filesDescsNew.length > 0) {
          let i = 0;
          for (const key in _product.filesDescsNew[0]) {
            if (_product.filesNew[i]) {
              _product.filesNew[i]["fileIndex"] = key;
            }
            let namaFile = _product.filesDescsNew[0][key].file_name ? _product.filesDescsNew[0][key].file_name : _product.filesDescsNew[0][key].fileName;
            filesDescsNew[key] = {
              fileIndex: key,
              fileName: namaFile,
              file_name: namaFile,
              media_desc: _product.filesDescsNew[0][key].media_desc ? _product.filesDescsNew[0][key].media_desc : _product.filesDescsNew[0][key][0].media_desc,
              media_types: _product.filesDescsNew[0][key].media_types
                ? _product.filesDescsNew[0][key].media_types
                : _product.filesDescsNew[0][key][0].media_type,
              content_types: _product.filesDescsNew[0][key].content_types
                ? _product.filesDescsNew[0][key].content_types
                : _product.filesDescsNew[0][key][0].content_type,
              skip: _product.filesDescsNew[0][key].skip,
            };
            i++;
          }
        }

        for (const key in _product.videoDescs[0]) {
          videoDescs[key] = {
            filePath: _product.videoDescs[0][key].filePath,
            fileName: _product.videoDescs[0][key].fileName,
            id: _product.videoDescs[0][key].id,
            media_types: _product.videoDescs[0][key].media_types,
            media_desc: _product.videoDescs[0][key].media_desc,
            content_types: _product.videoDescs[0][key].content_types,
            language_code: _product.videoDescs[0][key].language_code,
            language_name: _product.videoDescs[0][key].language_name,
          };
        }
        const filesUps = [];
        if (!_product.filesUps) {
          _product.productUps.forEach((item) => filesUps.push(item));
        }

        setTimeout(() => {
          setState({
            ...state,
            languages: _langs,
            fileExport: fExport,
            files: fImport,
            segments: _segment,
            assembles: _assembles,
            product: _product.product,
            productDetails: _product.productDetails,
            productHighlights: _product.productHighlights,
            video_types: _video_types,
            media_types: _media_types,
            filesNew: _product.filesNew,
            content_types: _content_types,
            filesUps: filesUps,
            productUps: _product.productUps
              ? _product.productUps
              : [
                  {
                    name: "",
                    media_code: "",
                    media_type: "",
                    media_desc: "",
                    content_type: "",
                    file_path: "",
                    tags: [],
                  },
                ],
            productEcom: _product.productEcom ? _product.productEcom : [{ id_store: "", url: "", price: "", line_num: 0 }],
            filesDescs: filesDescs,
            files: _product.files,
            filesDescsNew: filesDescsNew,
            deletedUps: _product?.deletedUps ? _product?.deletedUps : [],
            fileSelectedNew: _product.fileSelectedNew,
            filesDescsUps: filesDescsUps,
            filesDescsUpss: filesDescsUps,
            videoDescs: videoDescs,
            productDetail:
              _product.productDetails.length > 0
                ? _product.productDetails[0]
                : {
                    language_code: "",
                    language_name: "",
                    title: "",
                    header_description: "",
                    description: "",
                    feature: "",
                    including: "",
                    tagline: "",
                    price: 0,
                    manual_book: null,
                    is_preorder: 0,
                    is_rental: 0,
                    is_active: true,
                    is_publish_web: false,
                    is_me_by_modena: 0,
                    sku_me_by_modena: "",
                    sticker_price: 0,
                    seo_title: "",
                    seo_description: "",
                    url_ar: "",
                  },
          });
        }, 100);
      }
    });
  }, []);

  const { firstPrefix, secondPrefix, files, brandPrefix, media_types, content_types, selectedItemCode, countryChange } = state;

  useEffect(() => {
    const seriesCode = brandPrefix + firstPrefix + secondPrefix;
    setValue("series", seriesCode);
  }, [firstPrefix, secondPrefix, brandPrefix]);

  useEffect(() => {
    if (selectedItemCode != "") {
      const timeOut = setTimeout(() => {
        getProductsAll(
          {
            filterAnd: `item_code:${selectedItemCode},is_active:true`,
            perpage: 10,
          },
          ({ data }) => {
            setState({ ...state, products: data.data });
          },
        );
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedItemCode]);

  useEffect(() => {
    if (selectedSupplierCode != "" && selectedSupplierCode.length >= 4) {
      const timeOut = setTimeout(() => {
        getSeupplier(selectedSupplierCode, { perpage: 10 }, ({ data }) => {
          setState({ ...state, suppliers: data.data });
        });
      }, 350);

      return () => clearTimeout(timeOut);
    }
  }, [selectedSupplierCode]);

  useEffect(() => {
    if (!userInfo.access?.master_product_view?.can_view) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "You're not allowed to access that page!",
      });
      navigate("/");
    }
    $("#launch_date").datetimepicker({
      format: "YYYY-MM-DD",
    });
    $("#thickness").val(0);
  }, []);

  const propsDetailPage = {
    countryChange,
    state,
    setState,
  };

  const propsProductImage = {
    files,
    filesDescs,
    media_types,
    content_types,
  };

  const propsProductVideo = {
    videoDescs,
    media_types,
    content_types,
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">View Product</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/product-view">Product</NavLink>
                </li>
                <li className="breadcrumb-item active">View Product</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={processing} />
                <form className="form-edit-product">
                  <div>
                    <div className="tab">
                      <p className={state.activeTab === "tab1" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab1")}>
                        Product
                      </p>
                      <p className={state.activeTab === "tab2" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab2")}>
                        Product Detail
                      </p>
                      <p className={state.activeTab === "tab3" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab3")}>
                        Product Information
                      </p>
                    </div>

                    <div className="tabcontent">
                      {state.activeTab === "tab1" && (
                        <div className="card-body">
                          <div className="d-flex" style={{ justifyContent: "space-evenly" }}>
                            <SkuEdit product={product} />
                          </div>

                          <div className="dropdown-divider" />

                          <div className="row mb-2">
                            <div className="col-md-3">
                              <div>
                                <div className="text-secondary">Subcategory Prefix</div>
                                <p className="font-wei">
                                  {(product && product.item_code_array && `${product.item_code_array[0]}${product.item_code_array[1]}`) || "-"}
                                </p>
                              </div>
                              <div>
                                <div className="text-secondary">Brand</div>
                                <p>{(product && product.brand_name) || "-"}</p>
                              </div>
                              <div>
                                <div className="text-secondary">Segment</div>
                                <p>{(product && product.segment_name) || "-"}</p>
                              </div>
                              <div>
                                <div className="text-secondary">Category</div>
                                <p>{(product && product.category_name) || "-"}</p>
                              </div>
                            </div>

                            <div className="col-md-3">
                              <div>
                                <div className="text-secondary">Subcategory</div>
                                <p>{(product && product.sub_category_name) || "-"}</p>
                              </div>
                              {subsubcategories && (
                                <div>
                                  <div className="text-secondary">Sub - Subcategory</div>
                                  <p>{(product && product.sub_sub_category_name) || "-"}</p>
                                </div>
                              )}
                              <div>
                                <div className="text-secondary">Color</div>
                                <p>{(product && product.color_name) || "-"}</p>
                              </div>

                              <div className="form-group">
                                <div className="text-secondary">Country</div>
                                <p>{(product && product.country_name) || "-"}</p>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center align-items-center col-md-3">
                              <div className="text-center">
                                <div className="text-secondary">Barcode EAN-13</div>
                                <div className="mt-2">
                                  <p>
                                    {product && product.barcode_sni ? (
                                      <span className="text-success">{product.barcode_sni}</span>
                                    ) : (
                                      <span className="text-muted">No Barcode EAN-13</span>
                                    )}
                                  </p>
                                  <div
                                    className="w-100 scroll mt-2"
                                    style={
                                      darkMode
                                        ? {
                                            overflow: "auto",
                                            overflowX: "scroll",
                                            height: 70,
                                            background: "#ccc",
                                          }
                                        : {
                                            overflow: "auto",
                                            overflowX: "scroll",
                                            height: 70,
                                          }
                                    }
                                  >
                                    <canvas id="barcode"></canvas>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-flex justify-content-center align-items-center col-md-3">
                              <div className="text-center">
                                <div className="text-secondary">Serial Number</div>
                                <div className="mt-2">
                                  <p>
                                    {product && product.barcode_qr ? (
                                      <span className="text-success">{product.barcode_qr}</span>
                                    ) : (
                                      <span className="text-muted">No Serial Number</span>
                                    )}
                                  </p>
                                  <div className="w-100 mt-2" style={darkMode ? { height: 140, background: "#ccc" } : { height: 140 }}>
                                    <canvas id="qrcode"></canvas>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <ProductDimensionView watch={watch} />
                        </div>
                      )}

                      {state.activeTab === "tab2" && (
                        <div>
                          <h5 className="mt-2 font-weight-normal py-2">SKU Information</h5>
                          <div className="dropdown-divider" />
                          <div className="row pt-2">
                            <div className="col-md-3">
                              <div className="text-secondary">Item Name</div>
                              <p>{(product && product.item_name) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">SKU No.</div>
                              <p>{item_code || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Model Code</div>
                              <p>{(product && product.model_code) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Country</div>
                              <p>{(product && capitalizeFirstLetter(product?.country_name)) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Category</div>
                              <p>{(product && product.category_name) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Sub Category</div>
                              <p>{(product && product.sub_category_name) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Sub-subcategory</div>
                              <p>{(product && product.sub_sub_category_name) || "-"}</p>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-3">
                              <div className="text-secondary">Brand Name</div>
                              <p>{(product && product.brand_name) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Series Name</div>
                              <p>{(product && product.series_name) || "-"}</p>
                            </div>
                            <div className="col-md-3">
                              <div className="text-secondary">Segment Name</div>
                              <p>{(product && product.segment_name) || "-"}</p>
                            </div>
                          </div>

                          <div className="dropdown-divider" />

                          <div className="row pt-3">
                            {productDetails.map((item, i) => {
                              if (item.language_code) {
                                const index = canvasUrl.findIndex((e) => e.id == `qr-${item.item_code}-${item.language_code}`);
                                return (
                                  <div className="col-md-6" key={i}>
                                    <div className="card">
                                      <div className="card-body">
                                        <p>
                                          <b>O2O URL</b>
                                        </p>
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          <div>
                                            <canvas
                                              style={{ height: 120, width: 120 }}
                                              key={i}
                                              className="mt-2"
                                              id={`qr-${item.item_code}-${item.language_code}`}
                                            ></canvas>
                                          </div>

                                          <div className="ml-2">
                                            <span>
                                              <b>Language</b>
                                            </span>
                                            <p>{item.language_name}</p>
                                            <span>
                                              <b>URL</b>
                                            </span>
                                            <p>{canvasUrl[index]?.value}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </div>

                          <h5 className="mt-2 font-weight-normal py-2">Media Information</h5>
                          <div className="dropdown-divider" />
                          <div>
                            <ProductImageView {...propsProductImage} />
                          </div>
                          <div className="mt-4">
                            <ProductVideoView {...propsProductVideo} />
                          </div>
                        </div>
                      )}

                      {state.activeTab === "tab3" && (
                        <>
                          <h5 className="mt-2 font-weight-normal py-2">Product Information</h5>
                          <div className="dropdown-divider" />
                          <div className="mb-4">
                            <ProductDetailPageView {...propsDetailPage} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetailView;
